var React = require('react');

function LongArrowAltDown (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M168.11 44v301.94h-80V44a12 12 0 0 1 12-12h56a12 12 0 0 1 12 12z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M231.17 386.94L145.08 473a24 24 0 0 1-33.94 0l-86.06-86.09c-15.12-15.12-4.41-41 17-41h172.09c21.38.03 32.09 25.88 17 41.03z","className":"fa-primary","key":2})]);
}

LongArrowAltDown.defaultProps = {"viewBox":"0 0 256 512","className":"icon"};

module.exports = LongArrowAltDown;

LongArrowAltDown.default = LongArrowAltDown;
